export const CalculatorWoods_ = {
    props: {
        step: {}, // текущий номер шага
        stepg: {}, // текущий номер глобального шага
        view: {},
        configurator: {},
        resultator: {}
    },
    mounted () {
        this.configurator({
                steps: this.config.steps
            });
    },
    watch: {
        result: {
            handler(val, oval) {
                this.resultator(this.result);
            },
            deep: true
        }
    },
    methods: {
        goStep (n) {
            this.$emit('goStep', n+this.stepg-this.step)
        },
    }
}

export const board = {
    computed: {
        board () {
            return this.form.board?this.vars.boards[this.form.board]:false
        },
        bH () {
            if (this.board) {
                return this.board.H;
            }
            return 0;
        },
        bL () {
            if (this.board) {
                return this.board.L;
            }
            return 0;
        },
        bS () {
            return this.bL*this.bH;
        },
    },
}